exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CQO4w{color:#585858;font-size:14px;font-weight:400;margin-bottom:5px;padding-left:10px}._1t-bN{font-weight:700;margin-left:-10px}._2AebI{cursor:pointer}", ""]);

// exports
exports.locals = {
	"infoSection": "CQO4w",
	"infoTitle": "_1t-bN",
	"dots": "_2AebI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/CarDriveInfo/CarDriveInfo.css
// module id = 2716
// module chunks = 17 28